import * as React from 'react';
import Modal from 'react-modal';

// @ts-ignore
import CopySubscriberDialog from 'groups/components/CopySubscriberDialog';
import errorLogger from 'utils/errorLogger';
import { promiseRelationship } from 'chat/utils/ChatPromises';
// @ts-ignore
import Relationship from 'entities/Relationship';
// @ts-ignore
import RemoveMembersFromGroupDialog from 'groups/components/RemoveMembersFromGroupDialog';
import Subscriber from 'entities/Subscriber';
import ListBatchActions from 'components/ListSidebar/ListBatchActions';
// @ts-ignore
import { GroupInfo } from 'components/PeopleList/PeopleList';
// @ts-ignore
import { PeopleListRow } from 'components/PeopleList/PeopleListTableDataContainer';

export type Props = {
  rows: PeopleListRow[];
  onDeselectAll: () => void;
  groupInfo: GroupInfo;
  reloadList: () => void;
};

type State = {
  addModalOpen: boolean;
  removeModalOpen: boolean;
  relationships: Relationship[];
};

export default class GroupPeopleListBatchActions extends React.Component<Props, State> {
  state: State = {
    addModalOpen: false,
    removeModalOpen: false,
    relationships: [],
  };

  componentDidMount() {
    this.mounted = true;
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  mounted: boolean = false;

  shouldRenderAction = (permission: string) => {
    const { rows } = this.props;
    return rows.every(r => r.userInteractionPermissions[permission]);
  };

  afterRemovedUsers = () => {
    const { reloadList, onDeselectAll } = this.props;

    reloadList();
    onDeselectAll();
  };

  openAddUsersModal = () => {
    this.loadRelationships(this.props.rows)
      .then(relationships => {
        this.setState({
          relationships,
          addModalOpen: true,
        });
      })
      .catch(errorLogger('GroupPeopleListBatchActions openAddUsersModal failed'));
  };

  closeAddUsersModal = () => {
    if (this.mounted) {
      this.setState({
        addModalOpen: false,
      });
    }
  };

  openRemoveUsersModal = () => {
    this.setState({
      removeModalOpen: true,
    });
  };

  closeRemoveUsersModal = () => {
    if (this.mounted) {
      this.setState({
        removeModalOpen: false,
      });
    }
  };

  loadRelationships = async (rows: PeopleListRow[]) => {
    return Promise.all(
      rows.map(row => {
        return promiseRelationship(Subscriber.fromJSON(row.user));
      })
    );
  };

  actionDisabled = (rows: PeopleListRow[], permissionKey: string) => {
    return rows.some(r => !r.userInteractionPermissions[permissionKey]);
  };

  render() {
    const { groupInfo, onDeselectAll, rows, reloadList } = this.props;
    const { addModalOpen, removeModalOpen, relationships } = this.state;
    const tooltipContent =
      'Unavailable because you are not allowed to perform this action on one or more of the people in the selection';

    const actions = [
      {
        title: 'Add to another class',
        onClick: this.openAddUsersModal,
        disabled: this.actionDisabled(rows, 'canCopyToAnotherGroup'),
        subtext: 'Add the selected users to another class.',
        tooltip: tooltipContent,
      },
      {
        title: 'Remove',
        onClick: this.openRemoveUsersModal,
        disabled: this.actionDisabled(rows, 'canRemoveFromGroup'),
        subtext: `Remove these users from ${groupInfo.className}.`,
        tooltip: tooltipContent,
      },
    ];

    return (
      <ListBatchActions actions={actions} onDeselectAll={onDeselectAll} rows={rows}>
        <Modal isOpen={addModalOpen}>
          <CopySubscriberDialog
            relationships={relationships}
            onRequestHide={this.closeAddUsersModal}
            onSubscribe={reloadList}
          />
        </Modal>
        <Modal isOpen={removeModalOpen}>
          <RemoveMembersFromGroupDialog
            groupUuid={groupInfo.uuid}
            userIds={rows.map(row => row.user.id)}
            onRequestHide={this.closeRemoveUsersModal}
            onRemoval={this.afterRemovedUsers}
          />
        </Modal>
      </ListBatchActions>
    );
  }
}
